import { render, staticRenderFns } from "./HostCity.vue?vue&type=template&id=1967f5ed&scoped=true&"
import script from "./HostCity.vue?vue&type=script&lang=js&"
export * from "./HostCity.vue?vue&type=script&lang=js&"
import style0 from "./HostCity.vue?vue&type=style&index=0&id=1967f5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967f5ed",
  null
  
)

export default component.exports